import { setMailboxMessageConfiguration } from 'owa-options-core';
import MessageOptionState from '../store/schema/MessageOptionState';
import store from '../store/store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import MailboxMessageConfigurationOptions from 'owa-service/lib/contract/MailboxMessageConfigurationOptions';

export interface SaveMessageOptionState {
    optionState: MessageOptionState;
    userOptions: UserOptionsType;
}

export default select<SaveMessageOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveMessageOption')(async function saveMessageOption(state?: SaveMessageOptionState) {
        let { optionState, userOptions } = state;
        let serviceObject: MailboxMessageConfigurationOptions = {};

        if (optionState.emptyDeletedItemsOnLogOut !== null) {
            userOptions.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
            serviceObject.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
        }

        await setMailboxMessageConfiguration(serviceObject);
    })
);
